import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('CompanyCode?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('CompanyCode/show/'+id);
    },    
    create(params) {
        return Service().post('CompanyCode/create', params);
    },
    update(id, params) {
        return Service().post('CompanyCode/update/'+id, params);
    },
    delete(id) {
        return Service().post('CompanyCode/delete/'+id);
    }
}